// Sunday's brand colours, matching TeamsFeaturePanels on the website.
const SUNDAY_MAIN = '#FF17E9'
const SUNDAY_BG = '#FEF1FA'
const LOGO_MASK =
  'url(/assets/pricing/sunday.svg) no-repeat left center / contain'

const styles = () => ({
  root: {
    width: '100%',
    maxWidth: 1024,
    margin: '48px 0 0',
    padding: 48,
    borderRadius: 40,
    backgroundColor: SUNDAY_BG,
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 5fr) minmax(0, 7fr)',
    alignItems: 'center',
    gap: 48,
    '@media (max-width: 900px)': {
      gridTemplateColumns: '1fr',
      padding: 24,
      gap: 24,
    },
  },
  photoWrap: {
    width: '100%',
    maxWidth: 340,
    margin: '0 auto',
    aspectRatio: '1 / 1',
    borderRadius: 32,
    overflow: 'hidden',
    backgroundColor: 'rgba(255, 255, 255, 0.6)',
  },
  photo: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block',
  },
  brandRow: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '8px 16px',
  },
  logo: {
    display: 'inline-block',
    width: 104,
    height: 26,
    backgroundColor: SUNDAY_MAIN,
    mask: LOGO_MASK,
    WebkitMask: LOGO_MASK,
  },
  stat: {
    display: 'flex',
    alignItems: 'baseline',
    gap: 6,
    paddingLeft: 16,
    borderLeft: '1px solid rgba(0, 46, 71, 0.15)',
  },
  statValue: {
    color: SUNDAY_MAIN,
    fontFamily: 'Inter',
    fontSize: '18px',
    fontWeight: 700,
  },
  statLabel: {
    color: 'rgba(0, 46, 71, 0.6)',
    fontFamily: 'Inter',
    fontSize: '13px',
  },
  quote: {
    margin: '24px 0 0',
  },
  quoteText: {
    color: '#002E47',
    fontFamily: 'Inter',
    fontSize: '26px',
    fontWeight: 600,
    lineHeight: 1.25,
    letterSpacing: '-0.5px',
    '@media (max-width: 600px)': {
      fontSize: '21px',
    },
  },
  caption: {
    marginTop: 32,
  },
  name: {
    color: '#002E47',
    fontFamily: 'Inter',
    fontSize: '15px',
    fontWeight: 600,
  },
  role: {
    color: 'rgba(0, 46, 71, 0.6)',
    fontFamily: 'Inter',
    fontSize: '15px',
  },
})

export default styles
